export function formatTime(timestamp) {
    var time = new Date(timestamp);
    var today = new Date();
    var isToday = (time.toDateString() === today.toDateString());

    if (isToday) {
        return time.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'});
    } else {
        return time.toLocaleDateString([], {day: '2-digit', month: 'short', year: 'numeric'});
    }
}
